import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    addToPortfolio,
    getChangeInIndex,
    getmultiPortfolio,
    getPerformanceSummaryData,
    getPerformanceSummaryShare,
    getPortfolioData,
} from "../../../apihelper/portfolio";
import {Button, Skeleton, TextField, Typography, useMediaQuery} from "@mui/material";
import TableCardHook from "../../account/profile/tables/TableCardHook";
import TableHook from "../../account/profile/tables/TableHook";

import json2mq from "json2mq";
import {getFetchdropdown} from "../../../apihelper/cryptocurrencylist";

import {INDICES_COMPOSITION_CHANGE_MESSAGE, LOGIN_MESSAGE} from "../../../common/constant/SubscriptionMessage";
import {Add} from "@mui/icons-material";
import AddToPortfolioPopup from "../../AddToPortfolio";

export const ChangeInIndex = (props = {}) => {
    const {selectedPortfolio, selectedPortfolioId, selectedTotalPortfolioValue, isEligible, handleLoginClick} = props;

    const [portfolioid, setportfolioid] = useState("");

    const [portfolioName, setPortfolioName] = useState(selectedPortfolio);
    const [portfolioValue, setPortfolioValue] = useState(selectedTotalPortfolioValue);
    const mPortfolioName = selectedPortfolio;

    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    React.useEffect(() => {
        setPortfolioName(selectedPortfolio);
    }, [selectedPortfolio]);

    React.useEffect(() => {
        setPortfolioValue(selectedTotalPortfolioValue);
    }, [selectedTotalPortfolioValue]);

    React.useEffect(() => {
        setportfolioid(selectedPortfolioId);
    }, [selectedPortfolioId]);

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [activeTab, setActiveTab] = useState(0);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const [buySell, setbuySell] = React.useState("");
    const [selectedDate, handleDateChange] = useState("");
    const [slugdataNew, setSlugdataNew] = useState([]);
    const [index, setIndex] = useState(0);
    const [loader, setLoader] = useState(true);
    const [severity, setSeverity] = useState("info");
    const [open, setOpen] = React.useState(false);

    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const [slugdata, setSlugdata] = useState([]);
    const handleClose = () => setOpen(false);
    const [initialPage, setInitialPage] = useState(false);
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [slugpopupdataNew, setSlugpopupdataNew] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [unit, setUnit] = useState("");
    const [price, setPrice] = useState("");
    const [user_role, setuser_role] = useState("");

    useEffect(() => {
        if ((isEligible !== undefined && !isEligible) || !userData) {
            setLoader(false);
        }
    }, [isEligible]);

    useEffect(() => {
        if (!portfolioid || !isEligible) {
            return;
        }
        setIndex(0);
        setLoader(true);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getChangeInIndex({
            lastDate: 30,
            portfolio_id: portfolioid,
        }).then((res) => {
            if (res?.code === 200) {
                setSlugdata(res.data);
                setTableData(res.data);
                setuser_role(res.user_role);
                setLoader(false);
            } else {
                setSlugdata([]);
                setTableData([]);
                setuser_role([]);
                setLoader(false);
            }
        });
    }, [portfolioid, isEligible]);

    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        setMsgforUpdatePortfolio("loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        addToPortfolio({
            portfolio_type_id: portfolioid,
            existing_portfolio: "yes",
            user_id: userData.user_id,
            slug: slugpopupdataNew.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setOpen(false);
                setSeverity("info");
                setMsgforUpdatePortfolio(res.message);
                const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                setLoader(false);

                setTimeout(() => {
                    getPerformanceSummaryData({
                        slug: "",
                        portfolio_type_id: portfolioid,
                        user_id: userData.user_id,
                        start_index: `${index}`,
                        limit: `${10}`,
                        Token: userData.token,
                    }).then((res) => {
                        if (res.code === "200") {
                            setSlugdata(res.data);
                            setuser_role(res.user_role);

                            if (res.data.length === 0) {
                                setInitialPage(true);
                            }

                            setLoader(true);
                        }
                    });

                    getPortfolioData({
                        slug: "",
                        user_id: userData.user_id,
                        portfolio_type_id: portfolioid,
                        start_index: 0,
                        Token: userData.token,
                    }).then((res) => {
                        if (res.code === "200") {
                            setSlugdataNew(res.data);
                            setuser_role(res.user_role);
                            setportfolioid(res.portfolio_id);
                        }
                    });
                }, 2000);

                setUnit("");
                setbuySell("");
                setPrice("");
                handleDateChange("");
            } else {
                setSeverity("error");
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };

    const fetchDropdownOptions = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

        getFetchdropdown({
            user_id: userData.user_id,

            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setuser_role(res.user_role);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const handleOpen = (idx) => {
        fetchDropdownOptions();
        setSlugpopupdataNew({
            slugname: slugdataNew[idx].slug,
            slug: slugdataNew[idx].name,
            units: slugdataNew[idx].total_unit,
            pricetoday: slugdataNew[idx].crypto_price,
            logo: slugdataNew[idx].logo,
            current_Wlt: slugdataNew[idx].current_wallet,
        });
        setOpen(true);
    };
    const numericPortfolioValue = Number(portfolioValue?.replace(/[^0-9.-]+/g, ""));

    const tabData = tableData.map((portfolio, index) => [
        <div className="table-col-1 d-flex gap-3" key={portfolio.coin_name}>
            <img src={`${portfolio["logo"]}`} className="crypto_icon" alt="crypto_icon" />
            <span className="tab-text">{portfolio["slug"]}</span>
        </div>,
        `${!portfolio?.price ? "N/A" : `$${portfolio.price}`}`,

        `${
            portfolio["thirtyd_change"] && !isNaN(portfolio["thirtyd_change"])
                ? Number(portfolio["thirtyd_change"]).toFixed(1) + "%"
                : "NA"
        }`,
        portfolio["portfolio_date"],
        <div className="btn-2" key={portfolio.portfolio_name}>
            <button
                className={`btn rounded-pill shadow ${
                    portfolio.unit_change_type === "Added More" || portfolio.unit_change_type === "Newly Added"
                        ? "btn-success"
                        : "btn-danger"
                }`}
            >
                {portfolio.unit_change_type}
            </button>
        </div>,
        <div className="btn-2 d-flex justify-content-center gap-2" key={portfolio.portfolio_name}>
            <AddToPortfolioPopup
                slugName={portfolio.slug}
                triggerElement={
                    <button
                        type="button"
                        className="rounded-pill btn-3"
                        aria-label={"Buy"}
                        
                        onClick={() => console.log(`${index % 2 === 0 ? "Buy" : "Sell"} ${portfolio.slug}`)}
                    >
                        <img src="/images/icons/add_icon.svg" alt={"Buy"}  style={{width: "30px", height: "30px"}} />
                    </button>
                }
                headingText={"Add/Remove"}
            />
        </div>,
    ]);
    const leftRightMotion = `
  @keyframes leftRightMotion {
    0% {
      transform: translateX(-30px); /* Start 30px left of center */
    }
    50% {
      transform: translateX(30px);  /* Move 30px right of center */
    }
    100% {
      transform: translateX(-30px); /* Return to 30px left of center */
    }
  }
`;

    const tableHeader = [
        {label: "Crypto", key: "crypto", sorting: true},
        {label: "Price", key: "price", sorting: true},
        {label: "Last 30 Days", key: "thirtyd_change", sorting: true},
        {label: "Date", key: "portfolio_date", sorting: true},
        {label: "Action", key: "", sorting: false},
        {label: "", key: "", sorting: false},
    ];

    const [sorting, setSorting] = useState({key: "", order: ""});

    const mediaQueryVar = useMediaQuery(json2mq({minWidth: 900}));

    return (
        <div className="">
            {isEligible || loader ? (
                <>
                    <TableHook header={tableHeader} tableData={tabData} loading={loader} />

                    {/* for mobile */}
                    {tableData.map((portfolio, index) => (
                        <TableCardHook
                            key={index}
                            header={{
                                name: portfolio.slug,
                                icon: `${portfolio["logo"]}`,
                            }}
                            body={[
                                {key: "Price", value: `${!portfolio?.price ? "N/A" : `$${portfolio.price}`}`},

                                {
                                    key: "Last 30 Days",
                                    value: `${
                                        portfolio["thirtyd_change"] && !isNaN(portfolio["thirtyd_change"])
                                            ? Number(portfolio["thirtyd_change"]).toFixed(1) + "%"
                                            : "NA"
                                    }`,
                                },
                                {
                                    key: "Date",
                                    value: portfolio["portfolio_date"],
                                },
                                {
                                    key: "Action",
                                    value: (
                                        <p
                                            className={`rounded-pill shadow text-center text-white px-2 ${
                                                portfolio.unit_change_type === "Added More" ||
                                                portfolio.unit_change_type === "Newly Added"
                                                    ? "bg-success"
                                                    : "bg-danger"
                                            }`}
                                        >
                                            {portfolio.unit_change_type}
                                        </p>
                                    ),
                                },
                            ]}
                            footer={[
                                {
                                    button: (
                                        <AddToPortfolioPopup
                                            slugName={portfolio.slug}
                                            triggerElement={
                                                <button className="sm-btn-1 position-relative d-flex align-items-center">
                                                    <span>Add To Portfolio</span>
                                                </button>
                                            }
                                            headingText={"Add/Remove"}
                                        />
                                    ),
                                },
                                {
                                    label: "Add To Watchlist",
                                },
                            ]}
                        />
                    ))}
                    {loader &&
                        Array.from({length: 3}).map((_, index) => (
                            <TableCardHook
                                key={index}
                                header={{
                                    name: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    icon: (
                                        <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} width={40} />
                                    ),
                                }}
                                body={[
                                    {
                                        key: "Crypto",
                                        value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    },
                                    {
                                        key: "Price",
                                        value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    },
                                    {
                                        key: "Last 30 Days",
                                        value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    },
                                    {
                                        key: "portfolio_date",
                                        value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    },
                                    {
                                        key: "Action",
                                        value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                                    },
                                ]}
                                footer={[{label: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />}]}
                                loading={loader}
                            />
                        ))}
                    {user_role === "superuser" && (
                        <>
                            <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                <TextField
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => handleDateChange(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10.384px",
                                            border: "1px solid #1877F2",
                                            boxShadow: "none",
                                            width: "200%",
                                            height: "45px",
                                        },
                                    }}
                                />
                            </div>
                            <div style={{marginBottom: "25px"}}>
                                <p className="card__container__row3__r2__text" style={{fontSize: "14px"}}>
                                    Buy/Sell Price($)
                                </p>
                                <input
                                    style={{
                                        background: "#fff",
                                        padding: "20px",
                                        border: "1px solid #1877F2",
                                        borderRadius: "10.384px",
                                        width: "100%",
                                        height: "45px",
                                    }}
                                    className="card__container__row3__r2__input"
                                    min="1"
                                    max="10"
                                    type="number"
                                    placeholder=""
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                ></input>
                            </div>
                        </>
                    )}
                    {tabData.length == 0 && !loader && (
                        <div className="is-mobile pb-5">
                            <div className="d-flex justify-content-center my-auto fw-bold   ">No Data fount</div>
                        </div>
                    )}
                </>
            ) : (
                <div
                    style={{
                        position: "relative",
                        border: "1px solid #B6B6B8",
                        margin: "3% 0% 2% 0%",
                        padding: "2%",
                        borderRadius: "8px",
                        textAlign: "center",
                        height: "30vh",
                        overflow: "hidden", // Ensures content stays within the div
                    }}
                >
                    {/* Blurred background image */}
                    <div
                        style={{
                            backgroundImage: `url(${window.constants.asset_path}/images/default-recommed.png)`,
                            backgroundSize: "cover",
                            backgroundPosition: "center center",
                            filter: "blur(5px)",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 0,
                        }}
                    ></div>

                    {/* Overlay content without blur */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <style>{leftRightMotion}</style>
                        <div style={{position: "relative", width: "64px", height: "64px"}}>
                            {/* Lens image with left-right motion animation */}

                            {!isEligible || !userData ? (
                                <img
                                    src={window.constants.asset_path + "/images/lock.svg"}
                                    alt="lock"
                                    style={{
                                        width: "45px",
                                        height: "45px",
                                        cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                        if (!userData || !isEligible) {
                                            e.preventDefault(); // Prevent navigation

                                            const originalUrl = `${process.env.REACT_APP_HOME_URL}indices`; // Use backticks for template literals
                                            sessionStorage.setItem("originalUrl", originalUrl); // Save the original URL to sessionStorage

                                            handleLoginClick(); // Trigger the login click handler
                                        }
                                    }}
                                />
                            ) : (
                                <img
                                    src={window.constants.asset_path + "/images/lens.png"}
                                    alt="Searching Lens"
                                    style={{
                                        width: "64px",
                                        height: "64px",
                                        position: "absolute",
                                        animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                    }}
                                />
                            )}
                        </div>
                        <p
                            style={{
                                fontFamily: "Satoshi,sans-serif",
                                marginTop: "10px",
                                fontSize: "18px",
                                color: "black",
                            }}
                        >
                            <b>{!userData ? LOGIN_MESSAGE() : !isEligible && INDICES_COMPOSITION_CHANGE_MESSAGE()}</b>
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};
